import { SET_FILTER, CLEAR_FILTER } from "../actions/actionsConstants";

export const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTER:
      return { ...action.payload };
    case CLEAR_FILTER:
      return {};
    default:
      return state;
  }
};
